import { render, staticRenderFns } from "./pie.vue?vue&type=template&id=2f2a6d89&scoped=true"
import script from "./pie.vue?vue&type=script&lang=js"
export * from "./pie.vue?vue&type=script&lang=js"
import style0 from "./pie.vue?vue&type=style&index=0&id=2f2a6d89&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f2a6d89",
  null
  
)

export default component.exports